import React, { useEffect, useState } from 'react';
import { NavLink, Link } from 'react-router'; 
import './Profile.css';
import TableView from '../meTable/TableView';
import {ToNotify} from 'fast_inon';
import {Ts} from '../../config/switcher';

const T = (lang, value, key='profile') => Ts(lang, key, value)

const ProfileMain = ({lang, service, account, Login, link="/"}) => {

  const [label, Label] =  useState('')
  const [profile, Profile] = useState('hidden')
  
    const onProfile = (e) => {
        //alert(`onProfile ${profile}`)
      if(account?.connected) {
        const element = document.getElementById("ProfileItems")
        if(element) {
            //element.style.top = `${e.clientY+24}px`
            if(element.style.visibility==='hidden') {
              element.style.right = `5px`
              element.style.visibility = 'visible'
            }
            else {
              element.style.visibility = 'hidden'
            }
            Profile(element.style.visibility)
        }
      }
      else {
        Login(true)
      }
    }  
  
    useEffect(()=>{
      //alert(profile)
      let value = account.connected ? 'profile' : 'login'
      Label(T(lang, value))
      if(value=='login') {
        const element = document.getElementById("meProfile")
        element.style.border = '2px  solid #eee'
        element.style.backgroundColor = '#007bff'
        element.style.color = 'white'
      }

    },[profile, lang])

  return (
<>
    <li className="NavLink" id="meProfile" to={link} onClick={onProfile} >{label}</li>

    <ProfileMenu lang={lang} app={service.name} account={account} />

    <div className='whatsapp-us'>
    <Link to="https://wa.me/+212660800630" target="_blank" rel="noopener noreferrer">
      <img src={`${service.icons}wathsapp.png`} alt="wathsapp" title="wathsapp" />
    </Link>
</div>
</>
  )
}

const onMouseLeave = (event) => {
  //event.currentTarget.blur();
  const element = document.getElementById("ProfileItems")
  if(element) {
    element.style.visibility = 'hidden'
  }
};

const ProfileMenu = ({lang, app, account}) => {

    useEffect(()=>{
      const element = document.getElementById("ProfileItems")
      if(element) {
        const lis = element.querySelectorAll('li')
        lis.forEach(li => {
          if (!li.onclick) {
            li.onclick = onMouseLeave
          }
        })
      }
    },[])


  const onLogout = (e) => {
      //alert('remove localStorage')
      let store = localStorage.getItem(app)
      if(store) {
        localStorage.removeItem(app)
        window.location.reload()
      }
  }

  return (
    <div id="ProfileItems" style={{visibility:'hidden'}}>
      <ul>
        <li><NavLink to="/profile">{T(lang, 'profile')}</NavLink></li>
<div className="divider"></div>
        <li><NavLink to="/home">{T(lang, 'home')}</NavLink></li>
        <li><NavLink to="/sync">{T(lang, 'sync')}</NavLink></li>
        <li><NavLink to="/ocr">{T(lang, 'ocr')}</NavLink></li>
<div className="divider"></div>
        <li><NavLink to="/planner">{T(lang, 'planner')}</NavLink></li>
        <li><NavLink to="/note">{T(lang, 'note')}</NavLink></li>
<div className="divider"></div>
        <li><NavLink to="/plan">{T(lang, 'order')}</NavLink></li>
        <li><NavLink to="/setting">{T(lang, 'setting')}</NavLink> </li>
        <li><NavLink to="/#contact">{T(lang, 'contact')}</NavLink></li>
        
      </ul>
      {account?.role==='Admin'?
        <ul>
          <div className="divider" style={{marginBottom:'0.5rem'}}></div>
          <li><NavLink to="/admin">{T(lang, 'admin')}</NavLink></li>
          <li><a href="https://tech2us.ma" rel="noreferrer" target="_blank">Tech2us</a></li>
        </ul>
      :null}
      <div className="divider"></div>
      <ul>
          <li style={{display:'block'}} onClick={onLogout} >Sign Out</li> 
      </ul>

    </div>
  )
}

const ProfileView = ({lang, account}) => {
    const node = {entity:'Profile', id:1, parent:1}
    const [message, Message] = useState('')

    const onCell = (item) => {
        //alert(`node=${item.Value}`)
    }

  return (
    <div id="ProfileContainer">

    { account?.connected ?  
      <div className='CollapseTab'> 
        <TableView request={`/account/${node.entity}/${node.id}`} node={node} onChange={onCell} />
      </div>
    : <h2>{T(lang, 'login')}</h2> }

    <ToNotify 
        message={message}
        onClose={()=>{Message('')}}
    />

    </div>
  )
}

export {ProfileMain, ProfileMenu, ProfileView}
